<template>
  <v-card
    color="#eee"
    flat
    height="100%"
    class="d-flex flex-column"
  >
    <v-card-title class="text-h6">{{ title }}</v-card-title>
    <v-card-text>
      <p>{{ blurb }}</p>
    </v-card-text>
    <v-spacer></v-spacer>
    <v-card-actions>
      <v-spacer></v-spacer>
      <router-link :to="path"><v-btn outlined color="primary">Go</v-btn></router-link>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: ['title', 'blurb', 'path']
}
</script>
